const numeric = (value) => {
    if (value === null || value === undefined || value === "") return 0;
    const parsed = Number(String(value).replace(",", "."));
    return Number.isFinite(parsed) ? parsed : 0;
};

const checked = (value) => value === true || value === 1 || value === "1" || value === "true";

/**
 * Immediate UI projection of RPF26 RN1 col.1.
 *
 * The backend annual engine remains authoritative on save/generation.  This
 * projection only keeps the readonly RN field synchronized while the user is
 * editing linked quadri, using the formula in the official RPF26 instructions.
 */
export function calculateRpf26Rn1ReferenceIncome(form) {
    const quadri = form?.quadri || {};
    const rn = quadri.RN || {};
    const rb10 = quadri.RB10 || {};
    const rc16 = quadri.RC16 || {};
    const lc = quadri.LC || {};
    const lm38 = quadri.LM?.LM38 || {};
    const lm10 = quadri.LM?.LM10 || {};
    const lmReferenceIncome = lm38.reddito_soggetto_imposta_sostitutiva;

    const rc16Col3 = numeric(rc16.somme_tassazione_sostitutiva ?? rc16.RC016003);
    const rc16Col6 = checked(rc16.scelta_tassazione_sostitutiva ?? rc16.RC016006);

    return Math.round(
        numeric(rn.reddito_complessivo)
        + numeric(rb10.cedolare_21)
        + numeric(rb10.cedolare_10)
        + numeric(rb10.cedolare_26)
        + numeric(rc16.somme_ordinarie_da_assoggettare_sostitutiva ?? rc16.RC016009)
        + (rc16Col6 ? rc16Col3 : 0)
        + numeric(lc.redditi_diversi_base_21 ?? quadri.RL10?.RL010007)
        + numeric(lc.redditi_diversi_base_26 ?? quadri.RL10?.RL010008)
        + numeric(
            lmReferenceIncome === null || lmReferenceIncome === undefined || lmReferenceIncome === ""
                ? lm10.reddito_imponibile
                : lmReferenceIncome
        )
    );
}

export function applyRpf26LiveDerivedFields(form) {
    if (!form || typeof form !== "object") return form;
    form.quadri ||= {};
    form.quadri.RN ||= {};
    form.quadri.RN.reddito_riferimento_agevolazioni = calculateRpf26Rn1ReferenceIncome(form);
    return form;
}
